const MENU_TRACK = {
  src: "https://cdn.navalabs.io/audios/MENU_lzbqwr.ogg",
  volume: 0.4,
  loop: true,
} as const;

const MATCH_TRACK = {
  src: "https://cdn.navalabs.io/audios/MATCH_xyhhwm.ogg",
  volume: 0.4,
  loop: true,
} as const;

export { MENU_TRACK, MATCH_TRACK };
